/**
 * Revenue helpers for sales analytics.
 *
 * Note: theoretical recipe costing used to live here (loadRecipeCostByProduct)
 * but Business Health now uses ACTUAL costs — see lib/actualCogs.ts.
 * Menu Manager keeps its own theoretical min–max range for pricing decisions.
 */
export function lineRevenue(unitPrice: number, qty: number, discount: number | null | undefined) {
  return Number(unitPrice) * Number(qty) - Number(discount ?? 0);
}
